import styles from "./index.module.css";

const Checkbox = ({state,size,borderRadius,onClick,dataIndex})=>{
    return <div style={{width:size,height:size,borderRadius}} onClick={onClick} data-index={dataIndex} className={state?`${styles["container"]} ${styles["checked"]}`:`${styles["container"]}`}>
        <i class="bi bi-check" style={{fontSize:(size)}}></i>
    </div>
}

export default Checkbox;